export default __webpack_public_path__ + "static/media/VISA.c0df3aa3.svg";